// The dashboard's entry point: translations, server state (TanStack Query) and the routes.

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { applyStoredTheme } from '@cck/ui';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './i18n/index.ts';
import { ApiError } from './lib/api.ts';
import { router } from './router.tsx';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Client errors do not get better by retrying (except rate limits); server and network errors might.
      retry: (n, err) => n < 2 && !(err instanceof ApiError && err.status >= 400 && err.status < 500 && err.status !== 429),
    },
  },
});

applyStoredTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
